import { useFormikContext, getIn } from 'formik';
import * as React from 'react';

// Call cb ONLY once if count is > 0 and ONLY if count is incremented next time.
export function useEffectWhenCountIncremented(
  count: any,
  cb: (count: number) => void
): void {
  const lastCount = React.useRef(0);
  React.useMemo(() => {
    if (typeof count === 'number' && count > lastCount.current) {
      cb(count);
      lastCount.current = count;
    }
  }, [cb, count]);
}

const FormikGotoErrorOnSubmitEffectFn: React.FunctionComponent = () => {
  const formik = useFormikContext();
  const scrollToFirstFormikError = useScrollToFirstFormikError();

  const validateFinishedCount =
    formik && // if component is in React formik's context
    formik.isSubmitting && // and submitting
    !formik.isValidating && // and validation is finished
    Object.keys(formik.errors).length > 0; // and has errors
  // formik.submitCount; // then return submit count

  // useEffectWhenCountIncremented(
  //   validateFinishedCount,
  // scrollToFirstFormikError
  // );
  React.useEffect(() => {
    validateFinishedCount && scrollToFirstFormikError();
  }, [scrollToFirstFormikError, validateFinishedCount]);

  return null;
};

export const useScrollToFirstFormikError = () => {
  const { errors } = useFormikContext() ?? {}; // in case we inadvertently use it outside of formik context. It will not work, but should not crash like before.
  return React.useCallback(() => {
    setTimeout(() => {
      // Find first element which id or name is path to error and scroll to it
      // tslint:disable:no-string-literal
      const errorElement = Array.from(
        document.querySelectorAll(
          'form [id], form [name]'
        ) as NodeListOf<HTMLInputElement>
      ).find(
        (el) =>
          (el.id &&
            (getIn(errors, el.id) ||
              getIn(errors, el.id.replace('_', '.')) ||
              getIn(errors, el.id.replace(/_input$/, '').replace('_', '.')))) ||
          (el['name'] && getIn(errors, el['name']))
      );

      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth' });
        if (errorElement['focus']) {
          setTimeout(() => {
            (errorElement as any).focus();
          }, 250); // Focus only after 250ms when scroll animation if finished
        }
      }
    }, 100); // Ensure everything is rendered to make sure animation will be smooth
  }, [errors]);
};

export default FormikGotoErrorOnSubmitEffectFn;
